import Storage from '../common/utils/storage.es6';
import Intro from './intro.es6';
import MainVisual from './mainvisual.es6';
import DecoTargets from './decotargets.es6';
import Section from './section.es6';
import Acc from "./acc.es6";
import Character from "./character.es6";

export default class Main {
    constructor() {
        window.STORAGE = new Storage();

        this.init();
    }

    init() {
        this.intro = new Intro();
        this.mainvisual = new MainVisual(this);
        this.decotargets = new DecoTargets();
        this.acc = new Acc();
        this.character = new Character();
        window.section = new Section();
    }
}
